import styled, { keyframes } from "styled-components";

const rotateR = keyframes`
from {
    transform: translateY(0px) rotate(0);
}
to {
    transform: translateY(9px) rotate(45deg);
}
`;

const rotateL = keyframes`
from {
    transform: translateY(0px) rotate(0);
}
to {
    transform: translateY(-9px) rotate(-45deg);
}
`;

const Bar = styled.div`
  height: 3px;
  width: 25px;
  display: block;
  margin: 6px auto;
  position: relative;
  background-color: #000;
  border-radius: 10px;
  transition: 0.4s;
  &:nth-of-type(1) {
    animation: ${rotateR} 1.5s cubic-bezier(0.5, 0.2, 0.2, 1);
  }
  &:nth-of-type(2) {
    animation: fade 1.5s cubic-bezier(0.1, 0.8, 0.1, 1);
  }
  &:nth-of-type(3) {
    animation: ${rotateL} 1.5s cubic-bezier(0.5, 0.2, 0.2, 1);
  }
`;

const IconContainer = styled.div`
  position: relative;
  border: 5px solid transparent;
  border-radius: 100%;
  cursor: pointer;
  &.opened {
    ${Bar} {
      &:nth-of-type(1) {
        transform: translateY(9px) rotate(45deg);
      }
      &:nth-of-type(2) {
        opacity: 0;
      }
      &:nth-of-type(3) {
        transform: translateY(-9px) rotate(-45deg);
      }
    }
  }
  @media (min-width: 992px) {
    display: none;
  }
`;

const HeaderNavbarToggler = ({ onClick, isOpen }) => {
  return (
    <IconContainer onClick={onClick} className={isOpen ? "opened" : ""}>
      <Bar />
      <Bar />
      <Bar />
    </IconContainer>
  );
};

export default HeaderNavbarToggler;
